"use strict";

var debug = require("debug")("knack.formatter.formatters.signature");

/**
 * @alias "formatters.signature"
 * @param {Object} value
 * @param {String} value.svg
 * @return {String}
 */
var signatureFormatter = function signatureFormatter(value) {
  if (!value || !value.svg) {
    return "";
  }
  value = new Buffer.from(value.svg).toString("base64");
  var img = "<img src=\"data:image/svg+xml;base64,".concat(value, "\" />");
  return img;
};
module.exports = signatureFormatter;